export const imgRoot = '/src/img/';